// src\services\currentUserApi.ts
const API_BASE = process.env.REACT_APP_API_BASE || "https://naucnelku4.execute-api.ap-south-2.amazonaws.com/dev/usermanagement";


export type CurrentUserResp = {
  message: string;
  identityProvider: "auth0" | "azuread";
  user: any;
  roleAssignments?: Array<{
    status: "ACTIVE" | "DISABLED" | string;
    role?: { key?: string; name?: string };
  }>;
};


export async function fetchCurrentUser(accessToken: string): Promise<CurrentUserResp> {
  const res = await fetch(`${API_BASE}/api/auth0/currentUser`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });


  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data?.message || "Failed to fetch current user");
  return data as CurrentUserResp;
}


export function getActiveRoleKeys(payload: CurrentUserResp): string[] {
  return (payload.roleAssignments || [])
    .filter((ra) => ra?.status === "ACTIVE")
    .map((ra) => (ra?.role?.key || "").trim().toUpperCase())
    .filter(Boolean);
}



